import {connect} from 'react-redux'
import {Login} from './login'
import {doLogin, resetApp, setLoginMessage} from '../actions'
import {appDictionary} from "../../app"

const mapStateToProps = (state) => ({
  isLoggedIn: state.userManagement.isLoggedIn,
  loginMessage: state.userManagement.loginFailureMessage,
  dictionary: appDictionary(state),
})

const mapDispatchToProps = (dispatch) => ({
  login: (username, password, dictionary) => dispatch(doLogin(username, password, dictionary)),
  setLoginMessage: (message) => dispatch(setLoginMessage(message)),
  resetApp: () => dispatch(resetApp())
})

export const LoginConnected = connect(mapStateToProps, mapDispatchToProps)(Login)